// extracted by mini-css-extract-plugin
module.exports = {"closeAlertButton":"EGiftCard_closeAlertButton__2G5ak","imageUploader":"EGiftCard_imageUploader__ZWIGM"};